module.exports = "<iframe #iFrame id=\"homeIframe\" (load)=\"onIframeLoad()\" frameborder=\"0\" class=\"entityIframe\" [src]=\"gwtTimeTrackingUrl\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/time-tracking/entity-time-tracking.component.html
// module id = 2270
// module chunks = 0